// Upload a KML or KMZ file and return a polygon for map display and saving

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['errorMessage', 'file', 'form']

    upload(event) {
        event.preventDefault(event)

        const errorMessage = this.errorMessageTarget
        const fileField = this.fileTarget
        const form = this.formTarget

        errorMessage.textContent = ''

        let formData = new FormData()
        // to post forms we need to add the authenticity token
        const token_element = document.head.querySelector('meta[name="csrf-token"]')
        if (token_element) { // is not present in tests, so need this to avoid erroring
            formData.append('authenticity_token', token_element.content)
        }

        if (fileField.files && fileField.files[0]) {
            let file = fileField.files[0]
            formData.append('uploaded_flight_area_file', file, file.name)
            fetch("/convert_kml", {
                method: "POST",
                body: formData
            })
            .then(function(response) {
                if (!response.ok) {
                    return response.text().then(function(text) { throw new Error(text) })
                }
                return response.json()
            })
            .then(function(data) {
                const encoded = google.maps.geometry.encoding.encodePath(data['coordinates'])
                document.getElementById('uploaded-kml-div').textContent = encoded // this will trigger form_map_controller
                errorMessage.textContent = ''
                form.reset()
                bootstrap.Modal.getInstance(document.getElementById('upload-kml-file-modal'))?.hide()
            })
            .catch(function(error) { // :bad_request
                errorMessage.textContent = error.message
                form.reset()
            })
        } else {
            errorMessage.textContent = "No file selected"
        }

    }
}
